import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=75bb5238&scoped=true"
import script from "./Separator.vue?vue&type=script&lang=js"
export * from "./Separator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bb5238",
  null
  
)

export default component.exports